import { render, staticRenderFns } from "./ClinicDetailDialog.vue?vue&type=template&id=737cbbea&scoped=true"
import script from "./ClinicDetailDialog.vue?vue&type=script&lang=js"
export * from "./ClinicDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./ClinicDetailDialog.vue?vue&type=style&index=0&id=737cbbea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737cbbea",
  null
  
)

export default component.exports